import { AUTH_STORAGE_KEY, useAuthStore } from './auth.store';

/**
 * 탭 간 인증 상태 동기화.
 *
 * zustand persist 는 부팅 시 한 번만 localStorage 를 읽는다 — 다른 탭이 토큰을
 * 회전(로그인 · 자동 재발급)하거나 로그아웃해도 이 탭의 메모리에는 옛 토큰이
 * 남는다. 옛 리프레시 토큰으로 재발급을 시도하면 서버 회전 유예 창(10초)을 지나
 * "재사용(탈취 의심)" 으로 판정돼 세션 체인 전체가 폐기되고 강제 로그아웃된다.
 *
 * storage 이벤트는 "다른 탭"의 변경에만 발생하므로(자기 탭 쓰기는 제외),
 * 수신 시 스토어를 다시 하이드레이트해 항상 최신 토큰을 쓰게 한다.
 */
export const startCrossTabAuthSync = (): (() => void) => {
  const handleStorage = (event: StorageEvent): void => {
    if (event.key !== AUTH_STORAGE_KEY) {
      return;
    }

    // 삭제(로그아웃)도 rehydrate 가 처리한다 — 저장값이 없으면 초기 상태로 병합된다.
    void useAuthStore.persist.rehydrate();
  };

  window.addEventListener('storage', handleStorage);

  return () => window.removeEventListener('storage', handleStorage);
};
